import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class SDEKSuggestCityDto
*  
*/
export class SDEKSuggestCityDto extends ActiveModel {

/**
  * cityUuid
  * Идентификатор населенного пункта СДЭК<br>
  */
  @ActiveField()
  cityUuid?: string


  /**
  * code
  * Код населенного пункта СДЭК<br>  */
  @ActiveField()
  code?: number


/**
  * fullName
  * Наименование населенного пункта СДЭК (город, район, регион, страна)<br>
  */
  @ActiveField()
  fullName?: string


/**
  * countryCode
  * Код страны в формате ISO_3166-1_alpha-2<br>
  */
  @ActiveField()
  countryCode?: string
}
